// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__zB2Yr","empty":"ModalGraph_empty__2pp5z"};